// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

import * as DmsService from './../supports/dms-service';

export default function CopyDmsDialog(props) {

  const { open, onClose, sysID, folderID, folders } = props;



  const [toDms, setToDms] = useState("DMS_DE");
  const [actionLog, setActionLog] = useState("");
  const [running, setRunning] = useState(false);

  useEffect(() => {
    if (open) {
      setActionLog("");
    }
  }, [open])

  const selFolder = folders.find(f => f.id === folderID);
  const selFolderName = selFolder?.FolderName || "";
  const formTitle = `Copy Folder "${selFolderName}" across DMS`;

  const handleCloseClick = () => {
    onClose && onClose();
  }

  const handleChangeToDms = (e) => {
    setToDms(e.target.value);
  }

  const addLog = (aMsg) => {
    setActionLog((prevState) => prevState + aMsg + '\n');
  }

  const handleCopyClick = async () => {
    // console.log("sysID", sysID);
    // console.log("folderID", folderID);
    // console.log("folders", folders);
    setRunning(true);

    addLog('start')

    const xCopyFolder = async (xFolderID) => {
      const xFolder = folders.find(f => f.id === xFolderID)
      // console.log('xCopyFolder ~ xFolder:', xFolder)

      try {
        addLog(`Copy "${xFolder.FolderPath}" from ${sysID} to ${toDms}`);
        await DmsService.copyRootFolderBetweenDeptPromise(sysID, xFolder.FolderPath, toDms);
        addLog("Success")
      } catch (e) {
        addLog(`Fail: ${e.errMsg || e.message}`)
      }

      const folderChilds = folders.filter(f => f.ParentID === xFolderID)
      for (const f of folderChilds) {
        await xCopyFolder(f.id);
      }

    }

    await xCopyFolder(folderID);

    setRunning(false);

    addLog('end')
  }

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"xl"}
      aria-describedby="copydms-dialog-description"
    >
      <DialogTitle id="copydms-dialog-title">
        {formTitle}
      </DialogTitle>
      <DialogContent>
        <TextField
          id="to-dms"
          required
          disabled={running}
          sx={{ mt: 2 }}
          fullWidth
          label="To DMS (sysID)"
          value={toDms}
          onChange={handleChangeToDms}
        />
        <TextField
          id="outlined-multiline-static"
          label="Action"
          fullWidth
          multiline
          sx={{ mt: 2 }}
          rows={20}
          value={actionLog}
          InputProps={{
            readOnly: true,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={running} onClick={handleCloseClick}>Close</Button>
        <Button disabled={toDms === "" || running} onClick={handleCopyClick}>Go</Button>
      </DialogActions>
    </Dialog>

  );
}

CopyDmsDialog.propTypes = {
  open: PropTypes.bool,
  sysID: PropTypes.string,
  folderID: PropTypes.number,
  folders: PropTypes.array,
  onClose: PropTypes.func,
};
